import { useEffect } from 'react';
import { Footer2021, Header2021, make2021Href, use2021Page } from './shared';
import { indexHighlightVideos2021, index2021, newsAlert2021 } from './data';

const SmartCity2021 = () => {
  const { lang } = use2021Page(index2021.title.en);
  useEffect(() => {
    // Prevent browser auto-jump to stale anchors like #video on reload/back navigation.
    if (window.location.hash) {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
    window.scrollTo(0, 0);
    requestAnimationFrame(() => window.scrollTo(0, 0));
    setTimeout(() => window.scrollTo(0, 0), 120);
  }, []);

  return (
    <>
      <Header2021 lang={lang} currentPath="index" />
      <main>
        <div
          className="background-container"
          style={{
            marginTop: '8.1%',
          }}
        >
          <div className="videobtn"><a href="#video">{index2021.videoTitle[lang]}</a></div>
          <img src="/2021/images/index.png" style={{ visibility: 'visible', display: 'block', width: '100%' }} alt="" />
        </div>
        <div className="background-container" id="video" style={{ backgroundColor: '#ffffff' }}>
          <img className="index-event-img" src="/2021/images/index4.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info" style={{ marginTop: '5%' }}>
            <h3><b>{index2021.videoTitle[lang]}</b></h3>
            <div style={{ display: 'flex', width: '100%' }}>
              {indexHighlightVideos2021.map((v) => (
                <div
                  className="video-container"
                  style={{ margin: 10, flex: '1 1 0', minWidth: 0 }}
                  key={v.id}
                >
                  <div className="video-wrapper">
                    <iframe className="iframe" src={`https://www.youtube.com/embed/${v.id}?rel=0`} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ width: '100%', height: 'auto', minHeight: 270 }}></iframe>
                  </div>
                  <div><b>{v.title[lang]}</b></div>
                </div>
              ))}
            </div>
            <div style={{ display: 'inline-flex', float: 'right' }}>
              <div className="arrow"><div className="triangle-right"></div></div>
              <a href={make2021Href('highlight?tab=Video', lang)} style={{ textDecoration: 'none', fontSize: 20, fontWeight: 400 }}>{index2021.videoMore[lang]}</a>
            </div>
          </div>
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/index2.png)' }}>
          <img src="/2021/images/index2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="index-info-container background-info">
            <h1 style={{ lineHeight: '1.8rem' }}><b>{index2021.title[lang]}</b></h1>
            <p>{index2021.leadIn[lang]}</p>
          </div>
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/index3.png)', backgroundColor: '#cfcbcb00', marginTop: '-4px' }}>
          <img className="index-event-img" src="/2021/images/index3.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info event-details-info">
            <h1 className="index-event-title"><b>{index2021.eventTitle[lang]}</b></h1>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ width: '70%' }}>
                <h3 style={{ marginLeft: '25%' }}><b>{index2021.eventDateTitle[lang]}:</b></h3>
                {lang === 'zh' ? (
                  <p style={{ marginLeft: '25%' }}><span style={{ fontSize: '3rem' }}>2021年12月2日</span></p>
                ) : (
                  <p className="event-date-line" style={{ marginLeft: '25%' }}>
                    <span className="index-event-date">2</span>
                    <span style={{ fontSize: '3rem' }}><b> Dec</b> 2021</span>
                  </p>
                )}
              </div>
              <div className="index-venue-container" style={{ width: '30%' }}>
                <h3><b>{index2021.eventVenueTitle[lang]}:</b></h3>
                {lang === 'zh' ? <p>數碼港三座E區三樓<br />會議廳1-3</p> : <p>Function Room 1-3,<br />Level 3, Core E,<br />Cyberport 3</p>}
              </div>
            </div>
          </div>
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/index4.png)', marginBottom: '-5px' }}>
          <img src="/2021/images/index4.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <div className="index-category">
              <div><a href={make2021Href('awards', lang)}><img src={`/2021/images/award category bar${lang === 'zh' ? ' zh' : ''}.png`} alt="" /></a></div>
              <div><a href={make2021Href('judges', lang)}><img src={`/2021/images/Judging bar${lang === 'zh' ? ' zh' : ''}.png`} alt="" /></a></div>
              <div>
                <a
                  href={lang === 'zh' ? '/2018/zh' : '/2018'}
                >
                  <img src={`/2021/images/Related events bar${lang === 'zh' ? ' zh' : ''}.png`} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div className="newsAlert">
        <div className="content">
          <h1>{newsAlert2021[lang].title}</h1>
          <p>{newsAlert2021[lang].description}</p>
        </div>
        <div className="actions">
          <a className="btn learnMore" href={make2021Href('awards', lang)}>{newsAlert2021[lang].button1}</a>
          <a className="btn later" href="#">{newsAlert2021[lang].button2}</a>
        </div>
      </div>
      <Footer2021 lang={lang} />
    </>
  );
};

export default SmartCity2021;
